/*
 * Copyright (c) 2020, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { KeyList } from '../../data/interfaces';
import {
    CREATE_API_KEYS_CREDENTIALS_FAILURE, CREATE_API_KEYS_CREDENTIALS_REQUEST, CREATE_API_KEYS_CREDENTIALS_SUCCESS,
    DELETE_API_KEYS_CREDENTIALS_FAILURE, DELETE_API_KEYS_CREDENTIALS_REQUEST, DELETE_API_KEYS_CREDENTIALS_SUCCESS,
    FETCH_API_KEYS_CREDENTIALS_FAILURE, FETCH_API_KEYS_CREDENTIALS_REQUEST, FETCH_API_KEYS_CREDENTIALS_SUCCESS
} from '../types/credentials';

export const createApiKeysCredentialsRequest = () => {
    return {
        type: CREATE_API_KEYS_CREDENTIALS_REQUEST
    }
}

export const createApiKeysCredentialsSuccess = (key: KeyList) => {
    return {
        type: CREATE_API_KEYS_CREDENTIALS_SUCCESS,
        payload: key
    }
}

export const createApiKeysCredentialsFailure = (error: string) => {
    return {
        type: CREATE_API_KEYS_CREDENTIALS_FAILURE,
        payload: error
    }
}

export const fetchApiKeysCredentialsRequest = () => {
    return {
        type: FETCH_API_KEYS_CREDENTIALS_REQUEST
    }
}

export const fetchApiKeysCredentialsSuccess = (keys: KeyList) => {
    return {
        type: FETCH_API_KEYS_CREDENTIALS_SUCCESS,
        payload: keys
    }
}

export const fetchApiKeysCredentialsFailure = (error: string) => {
    return {
        type: FETCH_API_KEYS_CREDENTIALS_FAILURE,
        payload: error
    }
}

export const deleteApiKeysCredentialsRequest = () => {
    return {
        type: DELETE_API_KEYS_CREDENTIALS_REQUEST
    }
}

export const deleteApiKeysCredentialsSuccess = (keys: KeyList | null) => {
    return {
        type: DELETE_API_KEYS_CREDENTIALS_SUCCESS,
        payload: keys
    }
}

export const deleteApiKeysCredentialsFailure = (error: string) => {
    return {
        type: DELETE_API_KEYS_CREDENTIALS_FAILURE,
        payload: error
    }
}
